var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"nyeremenyjatek-osszegzo\"\u003E\u003Cp\u003EKöszönjük, hogy részt vett nyereményjátékunkban! Az eredményt e-mailben megküldtük a regisztráció során megadott e-mail címre!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/applications/nyeremenyjatek-osszegzo/nyeremenyjatek-osszegzo.pug
// module id = 307
// module chunks = 1